import { i18nTranslationHelper } from '@/i18n'
import { DependentEnrollmentResponse, DependentSettingsResponse } from './dependent-service-types'
import { formatDate } from '@/main/helpers'

const t = {
  enum: i18nTranslationHelper.getTEnums,
  page: i18nTranslationHelper.getTPage
}

export const formatDependentRequestSettings = (
  response: DependentSettingsResponse
): DependentSettingsResponse => {
  const formattedChargeTypes = response.chargeTypes.map(item => {
    const translationKey = `companyManager.dependentEnrollment.modals.approve.discountInput.options.${item.type}`
    return {
      ...item,
      name: t.page(translationKey) || item.name
    }
  })

  return {
    ...response,
    chargeTypes: formattedChargeTypes
  }
}

export const formatDependentRequestList = (
  response: DependentEnrollmentResponse
): DependentEnrollmentResponse => {
  const formattedItems = response.items.map(item => {
    const getDiscountFormatName = (key: string | null | undefined) =>
      key
        ? t.page(`companyManager.dependentEnrollment.modals.approve.discountInput.options.${key}`)
        : '--'

    return {
      ...item,
      formatOfDiscount: getDiscountFormatName(item.formatOfDiscount),
      degreeKinship: t.enum(`degreesKinship.${item.degreeKinship.toUpperCase()}.label`),
      birthDate: item.birthDate ? formatDate(new Date(item.birthDate.replace(/-/g, '/'))) : null,
      createdAt: item.createdAt ? formatDate(new Date(item.createdAt)) : null,
      analyzedAt: item.analyzedAt ? formatDate(new Date(item.analyzedAt)) : null,
      signedAt: item.signedAt ? formatDate(new Date(item.signedAt)) : null,
      canceledAt: item.canceledAt ? formatDate(new Date(item.canceledAt)) : null
    }
  })

  return {
    ...response,
    items: formattedItems
  }
}
